import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { store } from "@/store";
import { appGuidesApi } from "@/services/api.app-guides";
import { GUIDE_SLUG_PARAM } from "@/components/guides/guide-constants";

const MySpaceGuidesPage = lazy(() => import("@/pages/(home)/(my-space)/guides"));
const MySpaceGuideDetailPage = lazy(() => import("@/pages/(home)/(my-space)/guides/detail"));

export enum MS_GUIDES_PATH_SEGMENTS {
  ROOT = "guides",
  DETAILS = `:${GUIDE_SLUG_PARAM}`,
}

export const myspaceGuidesRoutes: RouteObject = {
  path: MS_GUIDES_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Guides" },
  HydrateFallback: Spinner,
  children: [
    { index: true, Component: MySpaceGuidesPage },
    {
      path: MS_GUIDES_PATH_SEGMENTS.DETAILS,
      // Same query args as the page, so this warms its cache (one request).
      loader: async ({ params }) => {
        const slug = params[GUIDE_SLUG_PARAM]!;
        const result = await store.dispatch(
          appGuidesApi.endpoints.getGuideBySlug.initiate({ slug, audience: "my_space" }),
        );
        return { breadcrumbLabel: result.data?.data?.title ?? "Guide" };
      },
      handle: {
        // Header title stays "Guides": the page's own hero shows the (often long) guide title.
        title: "Guides",
        breadcrumb: (data: { breadcrumbLabel?: string }) => data?.breadcrumbLabel ?? "Guide",
      },
      Component: MySpaceGuideDetailPage,
    },
  ],
};

export const MS_GUIDES_PATHS = Object.freeze({
  ROOT: addSlashes(MS_GUIDES_PATH_SEGMENTS.ROOT),
  VIEW: (slug: string) => addSlashes(MS_GUIDES_PATH_SEGMENTS.ROOT, encodeURIComponent(slug)),
});
